import { useQuery } from "@tanstack/react-query";
import { metricsApi, type MetricsFilter, type VolumePeriod } from "@/api/dealFlow/metrics";

// TanStack hooks keyed by [endpoint, filter, ...].
// 60s staleTime mirrors the server cache TTL so a tab switch within the
// same minute reuses the cached payload client-side, avoiding the
// 304 round-trip the Cache-Control: max-age=60 header would otherwise
// produce.

const STALE_60S = 60_000;

export const useMetricsPipeline = (filter: MetricsFilter) =>
  useQuery({
    queryKey: ["dfm", "pipeline", filter],
    queryFn: () => metricsApi.pipeline(filter),
    staleTime: STALE_60S,
  });

export const useMetricsVolume = (filter: MetricsFilter, period: VolumePeriod) =>
  useQuery({
    queryKey: ["dfm", "volume", filter, period],
    queryFn: () => metricsApi.volume(filter, period),
    staleTime: STALE_60S,
  });

export const useMetricsQuality = (filter: MetricsFilter) =>
  useQuery({
    queryKey: ["dfm", "quality", filter],
    queryFn: () => metricsApi.quality(filter),
    staleTime: STALE_60S,
  });

export const useMetricsFinancial = (filter: MetricsFilter) =>
  useQuery({
    queryKey: ["dfm", "financial", filter],
    queryFn: () => metricsApi.financial(filter),
    staleTime: STALE_60S,
  });

export const useMetricsAnalystLoad = (
  filter: MetricsFilter,
  enabled: boolean,
) =>
  useQuery({
    queryKey: ["dfm", "analyst-load", filter],
    queryFn: () => metricsApi.analystLoad(filter),
    staleTime: STALE_60S,
    enabled,
  });

export const useMetricsTimeToClose = (filter: MetricsFilter) =>
  useQuery({
    queryKey: ["dfm", "time-to-close", filter],
    queryFn: () => metricsApi.timeToClose(filter),
    staleTime: STALE_60S,
  });
